import * as Sentry from "@sentry/react"

/**
 * Initialise Sentry error monitoring.
 * Only runs when REACT_APP_SENTRY_DSN is set, so local dev is unaffected.
 */
export function initSentry() {
    const dsn = process.env.REACT_APP_SENTRY_DSN
    if (!dsn) return

    Sentry.init({
        dsn,
        environment: process.env.NODE_ENV,

        // Capture 10% of sessions for performance tracing in production;
        // 100% in non-production environments for easier debugging.
        tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

        // Only send errors in production; silence them in development.
        enabled: process.env.NODE_ENV === "production",

        // Strip auth tokens from request headers before sending to Sentry.
        beforeSend(event) {
            if (event.request && event.request.headers) {
                delete event.request.headers["Authorization"]
            }
            return event
        },
    })
}

/**
 * Manually capture an exception (use in catch blocks as a replacement
 * for console.error where you want the error tracked in Sentry).
 */
export function captureError(error, context = {}) {
    if (process.env.REACT_APP_SENTRY_DSN) {
        Sentry.captureException(error, { extra: context })
    } else {
        console.error(error, context)
    }
}
